import gql from 'graphql-tag';

export default gql`
  query referrerDetail {
    referrerDetail {
      referralCode
    }
  }
`;
